export default __webpack_public_path__ + "static/media/schema-bg-sm.a3d34b17.svg";